import React from 'react';
import { useSelector } from 'react-redux';
import Util from 'utility';

function DialogAssignmentInfo({ assignmentText }) {
    const data = useSelector(state => state);
    const { globals } = data;

    let fpid = Util.getFirstProfileId();
    if(typeof data.appModeData.profileId === 'number') fpid = data.appModeData.profileId;

    const profile = globals.profiles[fpid];
    const bmr = Util.getBMR(profile);

    let energCoef = globals.energyOutputCoefficients[profile.energy_output_coefficient];
    if(typeof data.appModeData.lectureInfoData.lecture_data.energy_coefficient_id === 'number') {
        const newCoefId = data.appModeData.lectureInfoData.lecture_data.energy_coefficient_id;
        energCoef = globals.energyOutputCoefficients[newCoefId];
    }

    return (
        <div className="p-[1em]" id="assignment-info">
            <style>{`
                    #assignment-info {
                    }
                    #assignment-info h2 {
                        color: #333;
                        font-size: 1.5em;
                        margin: 1.5rem 0 0.5rem 0;
                    }
                    #assignment-info ul {
                        list-style: disc;
                        margin-left: 1.5rem;
                    }
                    #assignment-info li {
                        margin-bottom: 0.5rem;
                    }
                    #assignment-info ol {
                        list-style: decimal;
                        margin-left: 1.5rem;
                    }
                `}</style>            
            <div dangerouslySetInnerHTML={{ __html: assignmentText }}></div>
        </div>
    );
}

export default DialogAssignmentInfo;
